import React from 'react';
import { Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Dispatch, iRootState } from '../redux/store';
import { QuoteStatuses, AnalyticsEventKeys } from '../constants';
import currentDate from '../currentDate';

const ConfirmFeedback = function ConfirmFeedback(): React.ReactElement {
  const dispatch = useDispatch<Dispatch>();
  const quoteId = useSelector((state: iRootState) => state.quote.id);
  const culture = useSelector((state: iRootState) => state.quote.culture);
  const fromName = useSelector((state: iRootState) => state.feedback.fromName);
  const fromEmail = useSelector(
    (state: iRootState) => state.feedback.fromEmail
  );
  const sending = useSelector((state: iRootState) => state.feedback.sending);
  const status = useSelector((state: iRootState) => state.quote.status);

  function getAnalyticsEventKey() {
    switch (status) {
      case QuoteStatuses.Accepted:
        return AnalyticsEventKeys.AcceptConfirmClicked;
      case QuoteStatuses.ChangesRequested:
        return AnalyticsEventKeys.RequestChangesConfirmClicked;
      default:
        return AnalyticsEventKeys.DeclineConfirmClicked;
    }
  }
  const analyticsEventKey = getAnalyticsEventKey();
  const onClick = async function handleOnClick(): Promise<void> {
    if (!quoteId) {
      return Promise.resolve();
    }
    dispatch.analytics.sendEvent({
      eventType: analyticsEventKey,
      eventProperties: {
        fromName,
        fromEmail
      }
    });
    dispatch.feedback.changeSending(true);
    const quoteFeedbackSaved = await dispatch.feedback.saveQuoteFeedback(
      status
    );
    if (status === QuoteStatuses.Accepted && quoteFeedbackSaved) {
      const dateNow = currentDate();
      dispatch.quote.setQuoteUpdatedDate(dateNow);
      dispatch.quote.setResponderName(fromName);
      dispatch.quote.signQuote();
      await dispatch.signPdf.sign({
        quoteId,
        fullName: fromName,
        signedOn: dateNow,
        culture
      });
    }

    return Promise.resolve();
  };

  return (
    <Button
      variant='contained'
      color='primary'
      onClick={onClick}
      disabled={sending}
    >
      <FormattedMessage id='confirm' defaultMessage='Confirm' />
    </Button>
  );
};

export default ConfirmFeedback;
